function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:#fff;}.cls-2{fill-rule:evenodd;}"));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M9.124,13.036c-2.274,0-4.124,1.85-4.124,4.125s1.85,4.125,4.124,4.125,4.125-1.851,4.125-4.125-1.851-4.125-4.125-4.125Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M9.124,36.233c-2.274,0-4.124,1.851-4.124,4.125s1.85,4.125,4.124,4.125,4.125-1.85,4.125-4.125-1.851-4.125-4.125-4.125Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M9.124,59.43c-2.274,0-4.124,1.851-4.124,4.125s1.85,4.125,4.124,4.125,4.125-1.851,4.125-4.125-1.851-4.125-4.125-4.125Z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M65.042,14.486H24.387c-1.475,0-2.674,1.199-2.674,2.674s1.199,2.674,2.674,2.674h40.655c1.475,0,2.674-1.2,2.674-2.674s-1.199-2.674-2.674-2.674Z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M21.713,40.357c0,1.475,1.199,2.674,2.674,2.674h17.91l.029-.268c.175-1.623.652-3.185,1.417-4.641l.23-.439h-19.586c-1.475,0-2.674,1.2-2.674,2.674Z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M21.713,63.555c0,1.475,1.199,2.674,2.674,2.674h8.78v-5.349h-8.78c-1.475,0-2.674,1.2-2.674,2.674Z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M57.015,68.29c-2.835,0-5.14-2.306-5.14-5.14s2.306-5.14,5.14-5.14,5.14,2.306,5.14,5.14-2.306,5.14-5.14,5.14Z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M47.949,78.862c-6.164,0-11.18-5.015-11.18-11.18v-9.065c0-4.732,2.995-8.969,7.453-10.544l1.613-.57v-2.714c0-6.164,5.015-11.179,11.179-11.179s11.18,5.015,11.18,11.179v2.714l1.612.57c4.458,1.575,7.453,5.813,7.453,10.544v9.065c0,6.165-5.015,11.18-11.18,11.18h-18.131ZM47.949,51.666c-3.833,0-6.95,3.118-6.95,6.951v9.065c0,3.833,3.118,6.951,6.95,6.951h18.131c3.833,0,6.951-3.118,6.951-6.951v-9.065c0-3.833-3.118-6.951-6.951-6.951h-18.131ZM63.966,47.437v-2.648c0-3.833-3.118-6.951-6.952-6.951s-6.95,3.118-6.95,6.951v2.648h13.902Z"
});

var SvgNavMenu02 = function SvgNavMenu02(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    viewBox: "0 0 80 80",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNavMenu02, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/nav_menu02.926cdab3.svg";
export { ForwardRef as ReactComponent };